import { useTranslation } from 'react-i18next'

import { Accordion, AccordionItem } from '../../Accordion'
import { SubMenuAccordionButton } from '../SubMenuAccordionButton'
import { SubMenuAccountList } from '../SubMenuAccountList'

import * as styles from './SubMenuAvailableItemsSection.module.css'

function SubMenuAvailableItemsSection({
  className = styles.SubMenuAvailableItemsSection,
  items,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      {items.length === 0 && (
        <div className={styles.noData}>{t('Select.NoDataKey')}</div>
      )}
      <Accordion
        variant
        ButtonComponent={SubMenuAccordionButton}
        className={styles.accordion}
      >
        {items.map((parentProps, ind) =>
          parentProps?.items ? (
            <AccordionItem {...parentProps} key={ind}>
              <SubMenuAccountList {...restProps} items={parentProps?.items} />
            </AccordionItem>
          ) : null
        )}
      </Accordion>
    </div>
  )
}

export default SubMenuAvailableItemsSection
